module.exports = __webpack_public_path__ + "img/icon_memberhome.27740293.svg";